import React from 'react'

const QuoteIcon = () => (
  <svg className='QuoteIcon' width='40' height='29' viewBox='0 0 40 29' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M31.03 15.659c-2.167-.25-3.959-1.136-5.376-2.656-1.416-1.521-2.125-3.282-2.125-5.282 0-2.125.698-3.916 2.094-5.375C27.02.888 28.738.16 30.78.16c2.334 0 4.355.948 6.063 2.844 1.708 1.895 2.562 4.198 2.562 6.906 0 8.125-4.52 14.479-13.562 19.062l-2.438-4.5c5.084-2.5 7.625-5.437 7.625-8.812zm-22.876 0c-2.208-.25-4.02-1.136-5.437-2.656C1.3 11.482.592 9.72.592 7.72c0-2.125.698-3.916 2.094-5.375C4.08.888 5.82.16 7.904.16c2.334 0 4.344.948 6.032 2.844 1.687 1.895 2.53 4.198 2.53 6.906 0 8.125-4.52 14.479-13.562 19.062l-2.437-4.5c5.125-2.5 7.687-5.437 7.687-8.812z'
      fill='#87D4F0' fillRule='evenodd' />
  </svg>
)

export default QuoteIcon



// WEBPACK FOOTER //
// ./client/components/QuoteIcon/QuoteIcon.js